import { useSearchParams } from "react-router-dom";

import { Spacing } from "manifest-components/src/Containers";
import { Button } from "manifest-components/src/Button";
import { RadioTile } from "manifest-components/src/Tiles/RadioTile";
import { useState } from "react";
import { confirmSignIn, fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";
import { Input } from "manifest-components/src/Inputs/Input";
import { RoutePaths, useTypedLocation, useTypedNavigate } from "../../routes/RoutePaths";
import PageLayout from "../../components/PageLayout";
import * as PageStyled from "../../components/HenryAssistedForm/styles";
import Authentication from "../../utils/authentication";

const MFA = () => {
  const [params] = useSearchParams();
  const [code, setCode] = useState<string>("");
  const [mfaDetails, setMFADetails] = useState<any>({});
  const navigate = useTypedNavigate();
  const choice = params.get("choice");
  const [userSelection, setUserSelection] = useState<string | null>(choice);
  const { state } = useTypedLocation();

  const confirmChoice = async () => {
    if (!userSelection) return;
    const confirmChoiceRes = await confirmSignIn({
      challengeResponse: userSelection, // 'EMAIL', 'SMS', or 'TOTP'
    });
    console.log({ confirmChoiceRes });
    setMFADetails(confirmChoiceRes);
    navigate(`${RoutePaths.mfa}?choice=${userSelection}` as RoutePaths);
  };

  const confirmCode = async () => {
    const confirmCodeRes = await confirmSignIn({
      challengeResponse: code,
    });
    console.log({ confirmCodeRes });

    if (confirmCodeRes.nextStep.signInStep === "DONE") {
      const userRes = await fetchUserAttributes();
      const userSessionRes = await fetchAuthSession();

      const accessToken = userSessionRes.tokens?.accessToken.toString();
      Authentication.authenticate({
        accessToken,
        userId: userRes.sub,
        email: userRes.email,
      });

      return navigate(RoutePaths.testHomePage);
    }
  };

  if (!choice) {
    return (
      <PageLayout pageId="mfa-choice">
        <PageStyled.HenryAssistedFormContainer>
          <h2>Choose a verification method</h2>
        </PageStyled.HenryAssistedFormContainer>
        <PageStyled.HenryAssistedFormMain>
          <RadioTile title="Email" onClick={() => setUserSelection("EMAIL")} selected={userSelection === "EMAIL"} />
          <Spacing $space={10} />
          <RadioTile title="Phone" onClick={() => setUserSelection("SMS")} selected={userSelection === "SMS"} />
        </PageStyled.HenryAssistedFormMain>
        <PageStyled.HenryAssistedFormFooter>
          <Button name="next" text="Next" onClick={confirmChoice} />
        </PageStyled.HenryAssistedFormFooter>
      </PageLayout>
    );
  }

  return (
    <PageLayout pageId="mfa-choice">
      <PageStyled.HenryAssistedFormContainer>
        <PageStyled.HenryAssistedFormHeader>
          <h2>Verify your identity </h2>
          {state.mfaDetails &&
            `A code has been sent via ${state.mfaDetails.deliveryMedium === "EMAIL" ? "email" : "SMS"} to ${
              state.mfaDetails.destination
            }. Code will be expired in 15 minutes`}
        </PageStyled.HenryAssistedFormHeader>

        <PageStyled.HenryAssistedFormMain>
          <Input type="text" name="mfaCode" value={code} onChange={setCode} />
        </PageStyled.HenryAssistedFormMain>
        <PageStyled.HenryAssistedFormFooter>
          <Spacing $space={60} />
          <Button name="next" text="Next" onClick={confirmCode} />
        </PageStyled.HenryAssistedFormFooter>
      </PageStyled.HenryAssistedFormContainer>
    </PageLayout>
  );
};

export default MFA;
